import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { Button, FormGroup, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import Input from 'v2/form/Input/Input';
import restFactory from 'v2/utils/restFactory';
import * as yup from 'yup';

export const SUBMIT_BTN_TEXT = 'Send Invitation';
interface InviteUserModalProps {
  show: boolean;
  hide: () => void;
  redirectUrl?: string;
}

interface InviteUserForm {
  email: string;
}

const schema = yup.object().shape({
  email: yup.string().email('Please enter a valid email').required('Required'),
});

const InviteUserModal = ({ show, hide, redirectUrl }: InviteUserModalProps) => {
  const history = useHistory();
  const [isBusy, setIsBusy] = useState(false);
  const queryClient = useQueryClient();
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<InviteUserForm>({
    mode: 'onChange',
    defaultValues: {},
    resolver: yupResolver(schema),
  });

  const onSubmit = (formData: InviteUserForm) => {
    setIsBusy(true);
    mutation.mutate(formData);
  };

  const mutation = useMutation(
    (data: InviteUserForm) =>
      restFactory.post('/dj/api/v1/invite_user/', {
        email: data.email,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('invitedUsers');
        toast.success('Invite was sent successfully.');
        reset();
        setIsBusy(false);
        redirectUrl && history.push(redirectUrl);
        hide();
      },
      onError: (error: Error) => {
        toast.error(String(error));
        setIsBusy(false);
      },
    }
  );

  return (
    <Modal show={show} onHide={hide} centered>
      <Modal.Header className="bg-light">
        <Modal.Title className="modalTitle pl-3">
          Invite Team Member
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <p className="text-light4 pt-4">
            Please provide the email address of the team member you would like
            to invite below.
          </p>
          <FormGroup>
            <span className="text-red font-weight-bold">
              {errors?.email?.message}
            </span>
            <Input
              className={!errors?.email?.message ? 'pt-4' : ''}
              type="text"
              register={register('email', { required: true })}
              maxLength={64}
              autoComplete="off"
              required={true}
              placeholder="Email Address"
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            className="btn-secondary-dark px-5"
            onClick={() => hide()}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isBusy}>
            {SUBMIT_BTN_TEXT}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default InviteUserModal;
